import { render } from "./ComponentNavbaraAdmin.vue?vue&type=template&id=31ca8378&scoped=true"
import script from "./ComponentNavbaraAdmin.vue?vue&type=script&lang=js"
export * from "./ComponentNavbaraAdmin.vue?vue&type=script&lang=js"

import "./ComponentNavbaraAdmin.vue?vue&type=style&index=0&id=31ca8378&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31ca8378"]])

export default __exports__